<template>
  <v-btn
    :color="color"
    outlined
    rounded
    @click="click"
    class="ma-1"
  >
    <v-icon left dark>{{ icon }}</v-icon>
    {{ text }}
  </v-btn>
</template>

<script>
export default {
  name: "LocationAttributeSwitchSimple",
  props: {
    text: {
      type: String,
      required: true
    },
    value: String,
    checked: Boolean
  },
  data: () => ({
    icon: 'mdi-plus',
    color: 'primary',
    myChecked: null
  }),
  created() {
    this.myChecked = this.checked

    if (this.checked) {
      this.icon = 'mdi-check'
      this.color = 'success'
    } else {
      this.icon = 'mdi-plus'
      this.color = 'primary'
    }
  },
  methods: {
    change: function() {
      this.$emit('change', this.myChecked)
    },
    click: function() {
      this.myChecked = !this.myChecked
      this.change()
    }
  },
  watch: {
    checked: function(val) {
      this.myChecked = val
    },
    myChecked: function(val) {
      if (val) {
        this.icon = 'mdi-check'
        this.color = 'success'
      } else {
        this.icon = 'mdi-plus'
        this.color = 'primary'
      }
    }
  }
}
</script>

<style scoped>

</style>